import { MorePageEffectProps } from "./type"
import React, { useLayoutEffect, useRef } from "react"
import styled, { useTheme } from '~/ui/styled'
import useNavigation from "~hooks/useNavigation"
import { CenterFlex, IconFont, StartFlex } from "~components/El"
import { Chat } from "~models/chat/chat"
import Avatar from "~widgets/avatar/Avatar"

const TouchableOpacity = styled(CenterFlex)`
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`

export const HeaderIconButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const theme = useTheme()
  return (
    <TouchableOpacity onClick={onClick}>
      <IconFont name="cjql" size={18} color={theme.colors.text} />
    </TouchableOpacity>
  )
}

export const HeaderSettingIconButton: React.FC<{ chat: Chat, onClick: () => void, onSharePress: () => void }> = ({
  onClick,
  onSharePress,
  chat
 }) => {
  const theme = useTheme()
  return (
    <StartFlex>
      <TouchableOpacity onClick={onSharePress}>
        <IconFont name="tuichu1" size={18} color={theme.colors.text} />
      </TouchableOpacity>
      {(chat.isCurrentUserIsAdmin || chat.isCurrentUserIsManager) && (
        <TouchableOpacity onClick={onClick}>
          <IconFont name="sz1" size={18} color={theme.colors.text} />
        </TouchableOpacity>
      )}
      
    </StartFlex>
    
  )
}

export const HeaderAvatarButton: React.FC<{ onClick: () => void, chat: Chat }> = ({ onClick, chat }) => {
  return (
    <TouchableOpacity onClick={onClick}>
      <Avatar size={30} avatar={chat.image} name={chat.displayTitle || chat.title} />
    </TouchableOpacity>
  )
}

const useMorePageEffect = (props: MorePageEffectProps) => {
  const { onMoreButtonPress } = props
  const navigation = useNavigation()
  const onMoreButtonPressRef = useRef(onMoreButtonPress)
  onMoreButtonPressRef.current = onMoreButtonPress

  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: function headerRight() {
        return <HeaderIconButton onClick={() => onMoreButtonPressRef.current()} />
      },
    })
    return () => {
      navigation.setOptions({ headerRight: undefined })
    }
  }, [navigation])
}

export default useMorePageEffect
